export default function (Vue) {
  var UNCONFIRMED_BOOKING_COLOR = '#C8E6C9'

  Vue.colorsConfig = {
    getUnconfirmedBookingColor () {
    return UNCONFIRMED_BOOKING_COLOR
  }

}
  Object.defineProperties(Vue.prototype, {
    $colorsConfig: {
      get: () => {
        return Vue.colorsConfig
      }
    }
  })
}
